<template>
    <div id="smart-area-selector-container" class="smart-area-selector-container--normal" style="padding: 0 8px; height: 100%; transform: translateZ(0);">
        <div v-if="isMounted" id="smart-area-selector" style="position: relative; max-height: 100%; width: auto;">
            <div v-for="(area, i) in areas" :key="area">
                <img v-once class="smart-area-selector--region-img" :src="baseUrl + 'images/regions/base_white_v2/' + area + '.png'">
                <img v-show="selectedRegions.includes(i)" class="smart-area-selector--region-img" style="will-change: display;" :src="baseUrl + 'images/regions/base_red_v2/'+ area + '.png'">
            </div>
            <img class="smart-area-selector--region-placeholder-img" :src="baseUrl + 'images/regions/base_white_v2/0.png'">

            <div style="position: absolute; left: 0; top: 0; right: 0; bottom: 0;">
                <img
                    v-for="(img, i) in images"
                    :key="img.key"
                    :src="getImageSrc(img.src)"
                    :style="img.style"
                    :class="[img.cssClass, isActiveImage(img) ? 'with-shadow' : '']"
                >

                 <div style="position: absolute; left: 0; top: 0; right: 0; bottom: 0;">
                     <div v-for="tId in allToothNumbers" :key="tId" v-show="$store.state.simplePlan.activeToothNumbers.includes(tId)">
                        <div class="roboto" style="position: absolute; vertical-align: baseline; text-align: center; color: #000; font-size: min(3.3em, 12px); font-weight: 600; text-shadow: 0 0 2px #fff,  0 0 3px #fff,  0 0 4px #fff,  0 0 2px #fff,  0 0 3px #fff,  0 0 4px #fff;" :style="getToothPosition(tId, true)">
                            {{ Helper.getToothNotation(tId) }}
                        </div>
                     </div>
                 </div>
            </div>

            <div id="Map" style="position: absolute; top: 0; left: 0; right: 0; bottom: 0;">
                <a v-for="(area, i) in areas"
                   v-once
                   :id="'area_selector_' + area"
                   :key="'area_selector_'+area"
                   class="area"
                   :style="areaPositions[area]"
                   @touchstart="handleClick(i)"
                />
            </div>
        </div>
    </div>
</template>
<style lang="scss">
    #smart-area-selector {
        max-height: inherit !important;
        transform: scale(0.95);
    }

    #smart-area-selector-container {
        display: flex; align-items: center; justify-content: center;
    }

    .smart-area-selector--region-placeholder-img {
        position: relative!important;
        width: auto!important;
        height: auto!important;
        transition: all .4s;

        .smart-area-selector-container--normal & {
            max-height: calc(100vh - 390px);
            max-width: 63vw;
        }
    }

    .smart-area-selector-container--normal, .smart-area-selector-container--normal #smart-area-selector {
        font-size: Calc((0.63) * 0.8vw); /* Base font size for EMs computed based on the grid */
        transition: all .4s;
    }


    #smart-area-selector:before {
        content: "";
        display: block;
        position: absolute;
        left: 13%;
        right: 13%;
        top: 9%;
        bottom: 9%;
        border-radius: 40%;
        background: rgba(0,0,0,.04);
        box-shadow: 0px 0px 30px rgba(0,0,0,.08);
    }
    #smart-area-selector img:not(.smart-area-selector--region-placeholder-img) {
        position: absolute;
        max-width: 100%;
        max-height: 100%;
        pointer-events: none;
    }

    .smart-area-selector--region-img {
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        width: 100%;
        height: 100%;
    }

    .outlined-text--white {
        text-shadow: 0 0 2px rgba(0,0,0,1);
        color: rgba(255,255,255,.9);
    }
    img.with-shadow {
        -webkit-filter: drop-shadow(0px 3px 0px rgba(0,0,0,.15));
        // filter: drop-shadow(0px 3px 0px rgba(0,0,0,.15));
        // filter: drop-shadow(0px 0px 2px #fff) drop-shadow(0px 0px 2px #fff) drop-shadow(0px 0px 2px #fff)
        filter: drop-shadow(1px 1px 1px #2862E6);
    }

@media (min-width: 700px) and (orientation: landscape) {
    #smart-area-selector {
        /*transform: scale(1);*/
    }
}
</style>

<script>
import RegionImageService from "../../extensions/services/region-image-service";
import ImageSrcProvider from "../../configs/image-src-provider";
export default {
    props: {
        steps: {
            type: Object,
            default: () => {
                return ([]);
            },
        },
    },

    created() {
        this.baseUrl = typeof FlutterSignOutService !== "undefined" ? "/" : "/";
        this.areas = ["a1814", "a2428", "a1323", "a4844", "a3438", "a4333"];
        this.areaPositions = RegionImageService.getAreaPositions();
        this.allToothNumbers = ['17', '16', '15', '14', '13', '12', '11', '21', '22', '23', '24', '25', '26', '27', '47', '46', '45', '44', '43', '42', '41', '31', '32', '33', '34', '35', '36', '37'];

        this.preloadImages(this.getPreloadQueue()).then(function(imgs) {
            // all images are loaded now and in the array imgs
        }, function(errImg) {
            // at least one image failed to load
        });

        this.$bus.$on("update-region-images", ()=>{
            this.getImages();
        });
    },

    data() {
        return ({
            selectedRegions: [],
            images: [],
            treatmentNumbers: {},
            isMounted: false,
            touched: false,
        });
    },

    mounted() {
        this.isMounted = true;
        this.getImages();
        this.selectedRegions = [this.$store.state.simplePlan.selectedRegion];
    },

    computed: {
        activeTreatmentPid() {
            return this.$store.state.simplePlan.activeTreatmentPid;
        },
        toothNumbers() {
            if (this.selectedRegions.length === 0 || this.steps.length === 0) return [];
            return this.selectedRegions[0] < 3 ? [17, 16, 15, 14, 13, 12, 11, 21, 22, 23, 24, 25, 26, 27] : [47, 46, 45, 44, 43, 42, 41, 31, 32, 33, 34, 35, 36, 37];
        },
    },

    methods: {
        handleClick(i) {
            this.touched = true;
            if (this.selectedRegions[0] === i) {
                this.deselect()
            } else {
                this.selectArea(i);
                this.$bus.$emit("region-selector:select", parseInt(i));
            }
            event.stopPropagation();
            event.preventDefault();
        },

        getImageSrc(src) {
            return ImageSrcProvider.getImage(src);
        },

        isActiveImage(img) {
            if (this.$store.state.simplePlan.selectedRegion < 0) return false;
            let pid = String(this.$store.state.simplePlan.activeTreatmentPid);
            if (pid === "11") pid = "13";
            return (this.$store.state.simplePlan.activeToothNumbers.includes(String(img.toothId)) && pid === String(img.stateId));
        },

        getPreloadQueue() {
            const path = "/images/regions/";
            const folders = ["base_white/", "base_red/"];
            const images = [];
            folders.forEach((folder) => {
                this.areas.forEach((area) => {
                    images.push(path + folder + area + ".png");
                });
            });
            return images;
        },

        preloadImages(srcs) {
            function loadImage(src) {
                return new Promise(function(resolve, reject) {
                    const img = new Image();
                    img.onload = function() {
                        resolve(img);
                    };
                    img.onerror = img.onabort = function() {
                        reject(src);
                    };
                    img.src = src;
                });
            }
            const promises = [];
            for (let i = 0; i < srcs.length; i++) {
                promises.push(loadImage(srcs[i]));
            }
            return Promise.all(promises);
        },


        getToothPosition(toothId, offset) {
            const style = RegionImageService.getToothStyle(toothId, "15", offset);
            if (toothId < 30) {
                if (toothId % 10 < 4) style.marginTop = "14%";
                else style.marginTop = "16%";
            } else {
                if (toothId % 10 < 4) style.marginTop = "6%";
                else style.marginTop = "4%";
            }
            return style;
        },

        reset() {
            this.selectedRegions = [];
            this.update();
            this.$forceUpdate();
        },

        // Called by parent
        update() {
            this.getImages();
        },

        getImages() {
            this.images = RegionImageService.getImages(this.steps);
        },


        deselect() {
            this.selectedRegions = [];
            // this.getImages(); // @removed 2020.05.19
            if (this.touched) this.$emit("select", this.selectedRegions);
            this.touched = false;
        },

        // called by parent
        selectArea(area) {
            this.selectedRegions.splice(0, this.selectedRegions.length);
            this.selectedRegions.push(parseInt(area));
            if (this.touched) this.$emit("select", this.selectedRegions);
            this.touched = false;
        },
    },
};
</script>
